import { Box, Stack, Typography } from "@mui/material"
import Section from "./Section"

function Bloc({ title, desc }: { title: string; desc: string }) {
  return (
    <Stack
      sx={{
        flex: 1,
        p: 1.5,
        borderRadius: "12px",
        background: "rgba(255, 255, 255, 0.02)",
        border: "1px solid rgba(255, 255, 255, 0.03)",
      }}
    >
      <Typography
        variant="h6"
        sx={{ pt: 1, pb: 1 }}
        fontWeight="bold"
        align="left"
      >
        {title}
      </Typography>
      <Typography color="rgb(154, 167, 180)" align="left">
        {desc}
      </Typography>
    </Stack>
  )
}

export interface OverviewProps {
  phone: boolean
}

export default function Overview({ phone }: OverviewProps) {
  return (
    <Section>
      <Stack spacing={4}>
        <Typography variant="h1" fontWeight="bold" width="100%" fontSize={45}>
          Optimisez les opérations dans vos entrepôts
        </Typography>
        <Stack
          direction={phone ? "column" : "row"}
          justifyContent="space-between"
          alignItems="center"
          spacing={5}
          width={"100%"}
        >
          <Stack alignItems="start" spacing={4}>
            <Typography
              color="rgb(154, 167, 180)"
              fontSize={"22px"}
              lineHeight={"24px"}
              align="left"
            >
              WM-UP combine simulation, solveurs et expertise terrain pour
              réduire les distances parcourues, rationnaliser le
              réapprovisionnement, accélérer le picking et améliorer la
              performance opérationnelle.
            </Typography>
            <Stack direction={phone ? "column" : "row"} spacing={3}>
              <Bloc
                title="Une application"
                desc="L'application met l'accent sur la facilité d'utilisation et elle permet d'optimiser les opérations de votre entrepôt tout en réduisant la charge qui pèse sur vos GDS."
              />
              <Bloc
                title="Du conseil"
                desc="Nous intervenons sur des problématiques qui nous permettent de valoriser notre application et notre expertise terrain."
              />
            </Stack>
          </Stack>
          <Box
            component="img"
            src="/laptop.png"
            width="100%"
            maxWidth="400px"
            sx={{
              borderRadius: "12px",
              boxShadow:
                "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.5)",
            }}
          />
        </Stack>
      </Stack>
    </Section>
  )
}
